import { metrics } from '@atlassian/browser-metrics';

export const METRICS_PAGE_ID = 'admin.contact-administrator';

export const contactAdminPageLoad = metrics.pageLoad({
	key: METRICS_PAGE_ID,
});
